import GrouponGSVG from "@design-system/ui-icons/vanilla/GrouponG"
import { createIcon } from "../createIcon"

export const GrouponGIcon = createIcon(GrouponGSVG)
